import { RETURN_PATH_QUERY_PARAM } from '@modules/common/constants';
import awsmobile from 'aws-exports';
import { getRedirectURI } from 'updatedConfig';

export const getSSORedirectionURL = (email: string, tenantSlug: string) => {
  if (!email || !tenantSlug) {
    return '/';
  }

  const searchParams = new URLSearchParams(window.location.search);
  const { [`${RETURN_PATH_QUERY_PARAM}`]: returnTo } =
    Object.fromEntries(searchParams);

  const oAuthState = Buffer.from(
    JSON.stringify({
      returnTo: returnTo ?? `/${tenantSlug}`,
    }),
  ).toString('base64');

  return `https://${
    awsmobile.oauth.domain
  }/authorize?response_type=code&client_id=${
    awsmobile.aws_user_pools_web_client_id
  }&redirect_uri=${
    getRedirectURI().redirectSignIn
  }&scope=openid+email&idp_identifier=${tenantSlug}&state=${oAuthState}`;
};
